import { FormControl, FormGroup } from '@angular/forms';
import { FilterService } from '../../services/filter.service';
import { Component, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Filter, FilterConfig, filters } from '../../configs/dashboard-filters.config';
import { DatePipe, formatDate } from '@angular/common';
import { MatExpansionPanel } from '@angular/material/expansion';
import { $Locale } from '@hubio/hubio-common-components';

@Component({
  selector: 'dashboard-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent {
  filters: Array<any>;
  filterForm: FormGroup = new FormGroup({});
  filterEventsSub: Subscription;
  @ViewChild('filterBar', { static: true }) public filterBar: MatExpansionPanel;

  constructor(
    public filterService: FilterService,
    public $Locale: $Locale,
    private datePipe: DatePipe
  ) {
    this.initFilters()
    this.filterEventsSub = this.filterService.events.subscribe(({ filter, clear }) => {
      if (filter || clear) this.resetFilters(filter);
      if (!clear && this.filterBar) {
        this.filterBar.close()
      }
    })
  }

  ngAfterViewInit(): void { 
    this.filterService.setPanel(this.filterBar); 
  }

  removeFilter(filter: Filter) {
    this.filterForm.patchValue({ [filter.name]: null });
    this.getFilters();
  }

  initFilters() {
    if (!this.filters) {
      const filtersConfig = filters
      this.filters = this.buildFilters(filtersConfig);
      this.getFilters()
    }
  }

  buildFilters(filtersConfig: FilterConfig) {
    const savedVals = this.filterService.lastAppliedFilters
    return filtersConfig.map(field => {
      const control = new FormControl();
      let initialValue;
      if (!savedVals) {
        initialValue = this.handleInitialValue(field);
      } else {
        initialValue = savedVals[field.name];
      }
      control.setValue(initialValue);

      if (field.disabled) {
        control.disable();
      }

      this.filterForm.addControl(field.name, control);

      return {
        ...field,
        abstractControl: control
      };
    })
  }

  getFilters() {
    const filter = this.parseFilterForm()
    this.filterService.newEvent({ filter });
  }

  resetFilters(newFilters?: object) {
    if (newFilters) {
      this.filterForm.reset(newFilters);
    } else {
      const formValues = {};

      //Persist disabled fields
      Object.keys(this.filterForm.controls).forEach(key => {
        formValues[key] = null;
        if (this.filterForm.get(key).disabled) {
          formValues[key] = this.filterForm.get(key).value
        }
      });
      this.filterForm.reset(formValues);
    }
  }

  private parseFilterForm() {
    let form = this.filterForm.getRawValue()
    for (const [field, value] of Object.entries(form)) {
      let parsedVal = value;
      if (value == null || (Array.isArray(value) && !value.length)) {
        delete form[field]
        continue
      }
      if (value instanceof Date) {
        parsedVal = this.datePipe.transform(value, 'yyyy-MM-dd');
      } else if (typeof value === 'string') {
        parsedVal = value.trim()
      }
      form[field] = parsedVal
    }
    return form
  }

  private handleInitialValue(field: FilterConfig[0]) {
    if (!field.defaultValue) return null;
    switch (field.type) {
      case 'date':
        if (field.defaultValue === 'TODAY') {
          return new Date();
        }
        return formatDate(new Date(field.defaultValue as string), 'yyyy-MM-dd', 'en');
      default:
        return field.defaultValue;
    }
  }

  displayTooltip(filterName: string) {
    const { value } = this.filterForm.get(filterName)
    if (Array.isArray(value)) {
      return value.join(', ')
    }
    return value
  }
  
  ngOnDestroy(): void {
    if (this.filterEventsSub)
      this.filterEventsSub.unsubscribe()
  }
}
